/*
 * @Descripttion :
 * @version      :
 * @Author       : ml
 * @Date         : 2020-08-03 18:49:40
 * @LastEditors  : ml
 * @LastEditTime : 2020-09-11 14:01:02
 */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		sessionKey: '',
		clientInstitutionID: '',
		sessionId: '',
		requestSource: '',
		bundleID: '',
		requestGroupID: '',
		channel: '',
		loginUserID: '',
		clientIP: '',
		endDeviceNumber: '',
		cityName: '',
	},
	mutations: {
		setUserInfo(state, obj) {
			state.sessionKey = obj.sessionKey
			state.clientInstitutionID = obj.clientInstitutionID
			state.sessionId = obj.sessionId
			state.requestSource = obj.requestSource
			state.bundleID = obj.bundleID
			state.requestGroupID = obj.requestGroupID
			state.channel = obj.channel
			state.loginUserID = obj.loginUserID
			state.clientIP = obj.clientIP
			state.endDeviceNumber = obj.endDeviceNumber
			state.cityName = obj.cityName
		},
	},
	actions: {},
	modules: {},
})
